function getMinMax(band) {
    const stats = band.statistics;
    if (typeof stats === 'undefined' || stats === null) {
        return "&rescale=0,2000";
    }

    let _min, _max;

    if (typeof stats.mean !== 'undefined' && typeof stats.stddev !== 'undefined') {
        _min = stats.mean - stats.stddev;
        _max = stats.mean + stats.stddev;
        console.log("Using mean and stddev for scaling: " + _min + ", " + _max)
    } else {
        _min = stats.minimum;
        _max = stats.maximum;
        console.log("Using min and max for scaling: " + _min + ", " + _max)
    }

    return "&rescale=" + _min.toString() + "," + _max.toString();
}

function getRescale(asset) {
    const classif = asset['classification:classes'];
    if (typeof classif !== 'undefined' && classif !== null) {
        if (typeof classif[0].color_hint != 'undefined') return "";

        const values = classif.map(item => item.value);
        let min = Infinity;
        let max = 0;
        for (let v of values) {
            if (v < min) min = v;
            if (v > max) max = v;
        }
        return "&rescale=" + min + "," + max;
    }

    let bands = asset['raster:bands'];
    if (typeof bands === 'undefined' || bands === null) {
        bands = asset['bands'];
    }
    if (typeof bands === 'undefined' || bands === null) {
        return "&rescale=0,2000";
    }

    const nBands = bands.length;

    if (nBands === 1) {
        return getMinMax(bands[0]) + "&bidx=1";
    }
    if (nBands === 2) {
        return getMinMax(bands[0]) + getMinMax(bands[1]) + getMinMax(bands[1]) + "&bidx=1&bidx=2&bidx=2";
    }
    return getMinMax(bands[0]) + getMinMax(bands[1]) + getMinMax(bands[2]) + "&bidx=1&bidx=2&bidx=3";
}


module.exports = {
    catalogUrl: null,
    catalogTitle: "STAC Browser",
    allowExternalAccess: true, // Must be true if catalogUrl is not given
    allowedDomains: [],
    detectLocaleFromBrowser: true,
    storeLocale: true,
    locale: "en",
    fallbackLocale: "en",
    supportedLocales: [
        "de",
//      "de-CH",
        "es",
        "en",
        "fr",
//      "fr-CA",
//      "fr-CH",
        "it",
//      "it-CH",
        "ro"
    ],
    apiCatalogPriority: null,
    useTileLayerAsFallback: false,
    tileSourceTemplate: null,
    displayGeoTiffByDefault: false,
    buildTileUrlTemplate: (asset) => "https://wmts.stac.teledetection.fr/cog/tiles/WebMercatorQuad/{z}/{x}/{y}@2x?url=" + encodeURIComponent(asset.getAbsoluteUrl()) + getRescale(asset),
    stacProxyUrl: null,
    pathPrefix: "/",
    historyMode: "history",
    cardViewMode: "cards",
    cardViewSort: "asc",
    showThumbnailsAsAssets: false,
    collectionsPerPage: 500,
    stacLint: true,
    geoTiffResolution: 128,
    redirectLegacyUrls: false,
    itemsPerPage: 12,
    defaultThumbnailSize: null,
    maxPreviewsOnMap: 50,
    crossOriginMedia: null,
    requestHeaders: {},
    requestQueryParameters: {},
    preprocessSTAC: null,
    authConfig: null
};